import { Button } from "@mui/material";
import { StyledFormikActions } from "../../styled/FormikActions";

const FormikActions = ({ handleCancel, cancel, submit, disabled, loading }) => {

  return (
    <StyledFormikActions.Container>
      {handleCancel && (
        <StyledFormikActions.CancelButton
          disabled={disabled || loading}
          onClick={handleCancel}
          color="primary"
          type="button"
        >
          {cancel ? cancel : "Cancelar"}
        </StyledFormikActions.CancelButton>
      )}
      <Button type="submit" color="primary" variant="contained" disabled={disabled || loading}>
        {submit ? submit : "Enviar"}
      </Button>
    </StyledFormikActions.Container>
  );
};

export default FormikActions;
